import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useStyles } from '../adminStyles';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import {
  getAppUserList,
  deleteUser,
  clearAppUser,
  getManagersUsers,
  getClientManagers
} from '../../../redux/appUsers/appUserActions';

import ExcelExport from './components/ExportExcel';
import UserTable from './components/UserTable';

const columns = [
  { id: 'empId', label: 'Emp Id' },
  { id: 'name', label: 'Name' },
  { id: 'role', label: 'Role' },
  { id: 'emailId', label: 'Email Id' },
  { id: 'defaultProject', label: 'Default Project' },
  { id: 'mobile', label: 'Mobile' },
  { id: 'action', label: 'Action' },
];

const TimesheetUsers = props => {
  document.title = 'Sciata Users';

  const { gridElLeft, gridElRight, selectEmpty, btnMobile, inputMobile } = useStyles();

  const dispatch = useDispatch();
  const users = useSelector(state => state.appUsers.usersList || []);
  const jobTitles = useSelector(state => state.appUsers.jobTitles || []);
  const currentUser = useSelector(state => state.users.currentUser);
  const managersUsers = useSelector(state => state.appUsers.managersUsers.body);
  const extUers = useSelector(state => state.users.allExtUser || []);
  const [orderAscending, setOrderAscending] = useState(true);
  const [asc, setAsc] = useState('desc');
  const [searchTerm, setSearchTerm] = useState('');
  const [rows, setRows] = useState([]);
  const [activeRecords, setActiveRecords] = useState(true);
  const [activeEmployees, setActiveEmployees] = useState(true);
  const [activeContractors, setActiveContractors] = useState(true);
  const [userRole, setUserRole] = useState('all');

  const onFieldChange = e => setUserRole(e.target.value);
  const bindUsers = () => dispatch(getAppUserList());
  const bindExtUsers = () => dispatch(getClientManagers());
  const bindManagersUsers = () => dispatch(getManagersUsers(currentUser.id));

  useEffect(() => {
    bindUsers();
    bindManagersUsers();
    bindExtUsers();
  }, []);

  useEffect(() => {
    let list = currentUser.role === 'manager' ? managersUsers : users;

    list &&
      setRows(
        list
          .filter(_usr => {
            return _usr.active === (activeRecords ? 1 : 0);
          })
          .map(_user => {
            const idx = _user.projects.findIndex(p => p.isDefault === true);
            let startDate = '';
            let endDate = '';
            if (idx !== -1) {
              startDate = _user.projects[idx].startDate || '';
              endDate = _user.projects[idx].endDate || '';
            }
            return {
              ..._user,
              name: (_user.firstName || '') + ' ' + (_user.lastName || ''),
              defaultProject: _user.defaultProjectName || 'N/A',
              defaultStartDate: startDate || 'N/A',
              defaultEndDate: endDate || 'N/A',
            };
          })
      );
  }, [users, managersUsers, activeRecords]);

  const sortArray = (arr, property) => () => {
    let array = [...arr];

    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');

    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) return -1;
            if (nameB > nameA) return 1;
            return 0;
          }
        })
      );
    }

    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const setTheSearchTerm = e => setSearchTerm(e.target.value);

  const userTableProps = {
    columns,
    rows,
    sortArray,
    orderAscending,
    asc,
    activeRecords,
    searchTerm,
    activeEmployees,
    activeContractors,
    userRole,
    users,
    jobTitles,
    currentUser,
    extUers,
    ...props,
  };

  return (
    <>
      <h1>Users</h1>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container alignItems='center'>
          <Grid item xs={12} md={3} className={gridElLeft}>
            <TextField
              variant='outlined'
              type='search'
              className={inputMobile}
              label='Search'
              value={searchTerm}
              onChange={setTheSearchTerm}
            />
          </Grid>
          <Grid item xs={12} md={6} container alignItems='center'>
            <Grid item xs={12} md={3}>
              <FormControl className={inputMobile} variant='outlined'>
                <InputLabel id='label'>Role</InputLabel>
                <Select
                  labelId='label'
                  name='userRole'
                  value={userRole || ''}
                  id='userRole'
                  label='Role'
                  onChange={onFieldChange}
                  required
                >
                  {['all', 'user', 'admin', 'manager'].map(role => (
                    <MenuItem value={role}>{role}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={activeEmployees}
                    onClick={e => {
                      setActiveEmployees(e.target.checked ? true : false);
                    }}
                    color='primary'
                  />
                }
                label={'Employees'}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={activeContractors}
                    onClick={e => {
                      setActiveContractors(e.target.checked ? true : false);
                    }}
                    color='primary'
                  />
                }
                label={'Contractors'}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={activeRecords}
                    onClick={e => {
                      setActiveRecords(e.target.checked ? true : false);
                    }}
                    color='primary'
                  />
                }
                label={activeRecords ? 'Active' : 'Inactive'}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={3} className={gridElRight}>
            <ExcelExport {...userTableProps} />
            {currentUser.role === 'manager' ? null : (
              <Button
                className={btnMobile}
                variant='contained'
                color='primary'
                startIcon={<PersonAddIcon />}
                onClick={() => {
                  dispatch(clearAppUser());
                  props.history.push('/admin/userdetails/0');
                }}
              >
                Add User
              </Button>
            )}
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
      <UserTable
        {...userTableProps}
        deleteUser={async userId => {
          const res = await dispatch(deleteUser(parseInt(userId)));
          if (res) {
            dispatch(getAppUserList());
          }
        }}
      />
    </>
  );
};

export default withRouter(TimesheetUsers);
